import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_decision_history } from '../services/api';
import { rootRoute } from "../../../config";
import { errorMsg } from "../../../helper/helpers";
import { motion } from "framer-motion";
import prevArrow from "../assets/prevArrow.png";
import leftArrow from "../assets/leftArrow.png";
import rightArrow from "../assets/rightArrow.png";
import clock from "../assets/clock.png";
import target from "../assets/target.png";
import profitreport from "../assets/profitreport.png";
import trophy from "../assets/trophy.png";
import ImModuleStyle from '../styles/im.module.css';

const DecisionHistory = () => {
   const location = useLocation();
   const navigate = useNavigate();
   const queryParams = new URLSearchParams(location.search);
   const [listOfUsers, setListOfUsers] = useState([]);
   const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
   const [decisionhistory, setDecisionhistory] = useState([]);
   const [attempt, setAttempt] = useState(queryParams.get("attempt"));
   const [pagination, setPagination] = useState({ "prev": false, "next": false });
   const [executioninstanceid, setExecutioninstanceid] = useState("");
   const [decisionPageHeight, setDecisionPageHeight] = useState("");
   const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError] = useOutletContext();

   let session_id = queryParams.get("sid");
   let resource_id = queryParams.get("resid");
   let course_id = queryParams.get("cid");
   let user_id = queryParams.get("userid");
   let attempt_id = queryParams.get("attempt");
   let role = queryParams.get("role");

   const checkNum = (num, factor) => {
      return num < 0
         ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
            minimumFractionDigits: factor,
            maximumFractionDigits: factor,
         })}`
         : `$${num?.toLocaleString(undefined, {
            minimumFractionDigits: factor,
            maximumFractionDigits: factor,
         })}`;
   };
   const initDecisionHistory = () => {
      (simObj?.status != 'COMPLETED' && (attempt == undefined && user_id == undefined)) && navigate(`${rootRoute}/im/simulation`);
      window.$("html, body").animate({ scrollTop: 0, }, 100);
      setIsLoader(true);
   };
   const backToSimulationList = () => {
      setIsLoader(true);
      if(role == "student"){
         navigate(rootRoute + `/im/studentreview?${queryParams}`);
      }else{
        navigate(rootRoute + `/im/instructorreview?${queryParams}`);
      }
   }
   const getNextAttempt = () =>{  
      setIsLoader(true);
      let index = simulationDetailSummary?.findIndex((sdObj)=> sdObj.attemptno == attempt);
      let currSdSObj = simulationDetailSummary[index + 1];
      if(currSdSObj != undefined){
        setAttempt(currSdSObj.attemptno);
        queryParams.set("attempt",currSdSObj.attemptno);
        setExecutioninstanceid(currSdSObj?.executioninstanceid);
        (simulationDetailSummary[index + 2] != undefined) ? setPagination({"prev":true,"next":false}) : setPagination({"prev":false,"next":true});
      }else{
        setPagination({"prev":false,"next":true});
        setIsLoader(false);
      }
    }
    const getPrevAttempt = () =>{ 
      setIsLoader(true);
      let index = simulationDetailSummary?.findIndex((sdObj)=> sdObj.attemptno == attempt);
      let currSdSObj = simulationDetailSummary[index - 1];
      if(currSdSObj != undefined){
        setAttempt(currSdSObj.attemptno);
        queryParams.set("attempt",currSdSObj.attemptno);
        setExecutioninstanceid(currSdSObj?.executioninstanceid);
        (simulationDetailSummary[index - 2] != undefined) ? setPagination({"prev":false,"next":false}) : setPagination({"prev":true,"next":false});
      }else{
        setPagination({"prev":true,"next":false});
        setIsLoader(false);
      }
    }
    const OnLoadPagination = () =>{  
        let lastObjIndex = simulationDetailSummary?.length -1;
        let firstObjIndex = 0;
        let currentIndex = simulationDetailSummary?.findIndex((sdObj)=> sdObj.attemptno == attempt);
        (currentIndex == lastObjIndex) && setPagination({"prev":false,"next":true});
        (currentIndex == firstObjIndex) && setPagination({"prev":true,"next":false});
        if((currentIndex != lastObjIndex) && (currentIndex != firstObjIndex)){
          setPagination({"prev":false,"next":false});
        }
    }
   const getSimulationDetailSummary = () => {
      setSimulationDetailSummary((attempt != undefined && user_id != undefined) ? simObj?.simulationdetails : []);
      setIsLoader(false);
   };
   const updateExcutionInstanceId = () => {
      if (attempt != undefined && user_id != undefined) {
         setExecutioninstanceid(simulationDetailSummary?.filter((sdObj) => sdObj.attemptno == attempt)[0]?.executioninstanceid)
      } else {
         setExecutioninstanceid(simObj?.executioninstanceid)
      }
   }
   const getDecisionHistory = () => {
      ((simObj?.sessionid != undefined || session_id != undefined) && executioninstanceid != undefined && executioninstanceid.length > 0) && get_decision_history((simObj?.sessionid || session_id), executioninstanceid).then(
         (response) => {
            if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
               setError(response?.data)
           }
           else{
            setDecisionhistory(response?.data);
            OnLoadPagination();
            setIsLoader(false);
            setIsOverlay(false)
           };
         }
      ).catch((error)=>{
         // setError(errorMsg);
         setError({"id":"00000","msg":errorMsg})
         console.log(error);
      })
   };

   useEffect(() => { updateExcutionInstanceId(); }, [simulationDetailSummary])
   useEffect(() => { 
      getSimulationDetailSummary();
      if(document.querySelector(`.${ImModuleStyle['decision-table']}`) != null ){
         document.querySelector(`.${ImModuleStyle['decision-table']}`).scrollTop = 0;
      };
    }, [attempt])
   useEffect(() => { getDecisionHistory(); }, [executioninstanceid])
   useEffect(() => {
      if(document.querySelector("header.header") != null){
         document.querySelector("header.header").style.display = "none";
       }
      document.querySelector(`.${ImModuleStyle['decisionhistory-container']} header.header h1`).tabIndex = -1;
      const decisionHistoryPageHeight = window.innerHeight - document.getElementsByClassName(`${ImModuleStyle.header}`)[0].clientHeight - document.getElementsByClassName(`${ImModuleStyle.header2}`)[0].clientHeight - document.getElementsByClassName(`ui grid ${ImModuleStyle.ui} ${ImModuleStyle.grid}`)[0].clientHeight - document.querySelector(`.footer`).clientHeight - 20;
      setDecisionPageHeight(decisionHistoryPageHeight);
      document.querySelector(".App .row").style.minHeight = "auto";
      initDecisionHistory();
      setAttempt(queryParams.get("attempt"));
      // if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
      //    document.querySelector("footer.footer .footer-nav .footer-links").style.display = "none";
      // }
      // if (document.querySelector("footer.footer .container") != null) {
      //    document.querySelector("footer.footer .container").style.justifyContent = "center";
      //  }
      if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
         document.querySelector("footer.footer .footer-nav .footer-links").firstChild.style.display = "none";
      }
    document.title = "Inventory Management | Decision History";
      return () => {
         document.querySelector(".App .row").style.minHeight = "100vh";
         if (document.querySelector(`.${ImModuleStyle['decisionhistory-container']} header.header`) != undefined) {
            document.querySelector(`.${ImModuleStyle['decisionhistory-container']} header.header`).style.display = "block";
         }
         if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
            document.querySelector("footer.footer .footer-nav .footer-links").style.display = "block";
         }
         if (document.querySelector("footer.footer .container") != null) {
            document.querySelector("footer.footer .container").style.justifyContent = "space-between";
          }
      };
   }, []);

   return (
      <motion.div className={`${ImModuleStyle['decisionhistory-container']}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
         <header className={`header ${ImModuleStyle.header}`}>
            <div className={`container ${ImModuleStyle.container}`}>
               <div className={`${ImModuleStyle['icon-header-box']}`}>
                  {
                     (attempt != undefined && user_id != undefined) && <button onClick={backToSimulationList}><img src={prevArrow} /></button>
                  }
               </div>
               <h1>Decision History</h1>
            </div>
         </header>
         <div className={`${ImModuleStyle['decisionhistory-wrapper']}`}>
            <div className={`${ImModuleStyle.header2}`}>
               <h3>
                  {attempt != undefined && `Inventory Management Simulation (Attempt ${attempt})`}
               </h3>

               <div>
                  {
                     (attempt != undefined && user_id != undefined && simulationDetailSummary?.length != 1) && <div className={`${ImModuleStyle['pagination-icons']}`}>
                        <button disabled={pagination.prev} onClick={getPrevAttempt}><img src={leftArrow} /></button>
                        <button disabled={pagination.next} onClick={getNextAttempt}><img src={rightArrow} /></button>
                     </div>
                  }
               </div>
            </div>
            <div className={`ui grid ${ImModuleStyle.ui} ${ImModuleStyle.grid}`}>
               <div className={`column ${ImModuleStyle.column}`}>
                  <img src={clock} />
                  <span>{decisionhistory?.summary?.startday}</span>
                  <p>Simulation Started</p>
               </div>
               <div className={`column ${ImModuleStyle.column}`}>
                  <img src={clock} />
                  <span>{decisionhistory?.summary?.endday}</span>
                  <p>Simulation Ended</p>
               </div>
               <div className={`column ${ImModuleStyle.column}`}>
                  <img src={target} />
                  <span>{checkNum(decisionhistory?.summary?.targetprofit)}</span>
                  <p>Target Net Profit</p>
               </div>
               <div className={`column ${ImModuleStyle.column}`}>
                  <img src={profitreport} />
                  <span>{checkNum(Number(decisionhistory?.summary?.grossprofit),2)}</span>
                  <p>Actual Profit</p>
               </div>
               <div className={`column ${ImModuleStyle.column}`}>
                  <img src={trophy} />
                  <span>{decisionhistory?.summary?.status}</span>
                  <p>Target Achieved</p>
               </div>
               <div className={`column ${ImModuleStyle.column}`}>
                  <img src={trophy} />
                  <span>{checkNum(Number(decisionhistory?.summary?.score))}%</span>
                  <p>Score</p>
               </div>
            </div>

            <div className={`${ImModuleStyle['decision-table']}`} style={{ height: decisionPageHeight + "px" }}>
               <table className={`ui unstackable table ${ImModuleStyle.ui} ${ImModuleStyle.unstackable} ${ImModuleStyle.table}`}>
                  <thead>
                     <tr>
                        <th className={`column`}>Simulation Duration</th>
                        <th className={`column`}>Orders Placed</th>
                        <th className={`column`}>Revenue for the Duration ($)</th>
                        <th className={`column`}>Cost for the Duration ($)</th>
                        <th className={`column`}>Net Profit for the Duration ($)</th>
                        <th className={`column`}>End-of-year projection based on current profit</th>
                     </tr>
                  </thead>
                  <tbody>
                     {
                        Array.isArray(decisionhistory?.detail) && decisionhistory?.detail?.map((detailObj,index) => (
                           <tr key={index}>
                              <td>{detailObj?.simulationPeriod}</td>
                              <td>
                                 {
                                    Array.isArray(detailObj?.decisionHistory) && detailObj?.decisionHistory?.map((dh,index) => (
                                       <React.Fragment  key={index}>
                                          <p>{dh.quantity} Units</p>
                                          <p className={`${ImModuleStyle['imp-txt']}`}>{dh.type.replaceAll("_"," ")}</p>
                                          <p className={`${ImModuleStyle['imp-txt']}`}>{dh.orderday}</p>
                                       </React.Fragment>
                                    ))
                                 }
                              </td>
                              <td>{checkNum(Number(detailObj?.revenue))}</td>
                              <td>{checkNum(Number(detailObj?.cost),2)}</td>
                              <td>{checkNum(Number(detailObj?.profit),2)}</td>
                              <td>{checkNum(Number(detailObj?.yearEndProjection),2)}</td>
                           </tr>
                        ))
                     }
                     <tr className={`${ImModuleStyle['total-row']}`}>
                        <td colSpan={2} className={`center aligned`}>Liquidation Revenue ({decisionhistory?.summary?.inventoryLeft} unit)</td>
                        <td>{checkNum(Number(decisionhistory?.summary?.liquidatedInventoryRevenue))}</td>
                        <td></td>
                        <td>{checkNum(Number(decisionhistory?.summary?.liquidatedInventoryRevenue))}</td>
                        <td></td>
                     </tr>
                     <tr className={`${ImModuleStyle['total-row']}`}>
                        <td colSpan={2} className={`center aligned`}>Totals</td>
                        <td>{checkNum(Number(decisionhistory?.summary?.grossRevenue))}</td>
                        <td>{checkNum(Number(decisionhistory?.summary?.grossCost),0)}</td>
                        <td>{checkNum(Number(decisionhistory?.summary?.grossprofit),0)}</td>
                        <td></td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
      </motion.div>
   );

};

export default DecisionHistory